<template>
  <div class="esign-rf-tools">
    <!--在线客服-->
    <div class="tools-item">
      <div class="tools-item-left kefu-tools-item-left">
        <BasicsCard class="tools-card" layout="horizontal" title="售前客服咨询" desc="客服一对一在线沟通" @click="openKefu('kefu')">
          <div slot="left-block" class="img-wrapper">
            <img src="https://trial-cdn.esign.cn/upload/142771ff-8154-5526-991e-33ba4454aaa2!!5-29.png" alt="售前" />
          </div>
        </BasicsCard>
        <BasicsCard class="tools-card" layout="horizontal" title="使用问题咨询" desc="提供售后咨询服务" @click="openKefu('shouhou')">
          <div slot="left-block" class="img-wrapper">
            <img src="https://trial-cdn.esign.cn/upload/19492309-291c-59b4-a6cb-34d2d6e0d576!!5-29.png" alt="售后" />
          </div>
        </BasicsCard>
      </div>
      <div class="tools-item-right tools-item-right-red" @mouseenter="enter('kefu')" @mouseleave="leave">
        <RightSideKefu :color="'#ffffff'" />
        <p class="tools-item-right-text">在线客服</p>
      </div>
    </div>
    <!--电话咨询-->
    <div class="tools-item">
      <div class="tools-item-left tel-tools-item-left">
        <a href="tel:0571-85785223" class="tools-card-wrapper">
          <BasicsCard class="tools-card" layout="horizontal" title="销售热线" desc="0571-85785223">
            <div slot="left-block" class="img-wrapper">
              <img src="https://trial-cdn.esign.cn/upload/49995bbe-fd13-5c55-94a4-609f5b06ad25!!5-29.png" alt="" />
            </div>
          </BasicsCard>
        </a>
        <a href="tel:4000878198" class="tools-card-wrapper">
          <BasicsCard class="tools-card" layout="horizontal" title="售后服务" desc="400-0878-198">
            <div slot="left-block" class="img-wrapper">
              <img src="https://trial-cdn.esign.cn/upload/8206eb8a-8958-5487-acc4-1d5a7802bfb9!!5-29.png" alt="" />
            </div>
          </BasicsCard>
        </a>
      </div>
      <div class="tools-item-right tools-item-right-red" @mouseenter="enter('phone')" @mouseleave="leave">
        <RightSidePhone :color="'#ffffff'" />
        <p class="tools-item-right-text">电话咨询</p>
      </div>
    </div>
    <!--微信咨询-->
    <div class="tools-item">
      <div class="tools-item-left  weixin-tools-item-left">
        <img src="https://trial-cdn.esign.cn/upload/7c26c557-2a60-5c2d-8aac-60fa0df2b4d4!!5-29.png" alt="微信咨询" />
        <div class="text">
          <p class="text-add-frends">扫码添加好友</p>
          <p class="text-receive">领取行业解决方案</p>
        </div>
      </div>
      <div class="tools-item-right tools-item-right-red" @mouseenter="enter('weixin')" @mouseleave="leave">
        <RightSideWeixin :color="'#ffffff'" />
        <p class="tools-item-right-text">微信咨询</p>
      </div>
    </div>
    <!--体验中心-->
    <div class="tools-item">
      <div class="tools-item-left weixin-tools-item-left">
        <img src="https://trial-cdn.esign.cn/upload/3b8e5dcb-963c-5394-b2fb-fe299e4433a5!!5-29.png" alt="体验中心" />
        <div class="text">
          <p class="text-add-frends">体验中心</p>
          <p class="text-receive">微信扫码免费体验</p>
        </div>
      </div>
      <div class="tools-item-right tools-item-right-red" @mouseenter="enter('experience')" @mouseleave="leave">
        <RightSideExperience :color="'#ffffff'" />
        <p class="tools-item-right-text">体验中心</p>
      </div>
    </div>
    <!--回到顶部-->
    <div v-show="showTop" :class="['tools-item-top']" @click="backTop">
      <div
        class="tools-item-top-right"
        :class="[hoverKey === 'top' ? 'tools-item-right-red' : '']"
        @mouseenter="enter('top')"
        @mouseleave="leave"
      >
        <RightSideTop :color="hoverKey === 'top' ? '#ffffff' : 'rgba(0, 0, 0, .45)'" />
      </div>
    </div>
  </div>
</template>
<script>
import BasicsCard from './BasicsCard.vue'
import RightSideTop from './RightSideTop.vue'
import RightSideKefu from './RightSideKefu.vue'
import RightSidePhone from './RightSidePhone.vue'
import RightSideWeixin from './RightSideWeixin.vue'
import RightSideExperience from './RightSideExperience.vue'
import baiduMixin from '../../mixins/baidu'
import qiyuMixin from '../../mixins/qiyu'
export default {
  name: 'SideBar',
  mixins: [baiduMixin, qiyuMixin],
  components: {
    RightSideKefu,
    RightSidePhone,
    RightSideWeixin,
    RightSideTop,
    BasicsCard,
    RightSideExperience,
  },
  props: {},
  data() {
    return {
      hoverKey: null,
      showTop: false,
      timer: null,
    }
  },
  mounted() {
    this.addQiyuScript()
    this.addAffScript() // 注册脚本
    window.addEventListener('scroll', () => {
      this.canShowTop()
      // if (this.timer) clearTimeout(this.timer)
      // this.timer = setTimeout(() => {
      //   this.canShowTop()
      // }, 500)
    })
  },
  // beforeDestroy() {
  //   if (this.timer) clearTimeout(this.timer)
  // },
  methods: {
    canShowTop() {
      const scrollDistance = window.scrollY || document.documentElement.scrollTop
      // 定个距离
      this.showTop = scrollDistance > 1300
    },
    backTop() {
      this.$tsignData.track('click_back_top', { $url: window.location.href })
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openKefu(type) {
      if (this.landingPageName === 'esignPropagate') {
        // eslint-disable-next-line camelcase
        window.meteor && window.meteor.track && window.meteor.track('consult_effective', { convert_id: '1655145710006284' })
      }
      this.$tsignData.track('click_customer_service')
      this.$tsignData.track('sign_landingpage_onlineservice')
      if (type === 'kefu') {
        this.handleNewBaiduService()
      }
      if (type === 'shouhou') {
        window.ysf('config', {
          // 官网的那套 主要配置各种ID
          // title: 'SAAS官网首页（未登录）', // 自定义访客咨询来源页的标题
          referrer: window.location.href, // 自定义访客咨询来源页的url
          groupid: '398550496', // 客户组id
          // groupid: '481134589',// 测试用的-客户组id
          robotShuntSwitch: 1, // 机器人开关 1机器人优先
          // robotShuntSwitch: 0, // 测试用的-机器人开关 1机器人优先
          robotId: 3464821,
          welcomeTemplateId: 705,
          qtype: 4490175,
          success() {
            if (/(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent)) {
              // 移动端
              window.location.href = window.ysf('url')
            } else {
              // pc端
              window.ysf('open', {
                templateId: 6631420, // 会话框模板ID 生效位置
              })
            }
          },
        })
      }
    },
    enter(hoverKey) {
      this.hoverKey = hoverKey
    },
    leave() {
      this.hoverKey = null
    },
  },
}
</script>

<style lang="less" scoped>
.esign-rf-tools {
  width: 84px;
  height: 400px;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 100001;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.tools-item {
  width: 64px;
  height: 64px;
  border-radius: 2px;
  margin-bottom: 14px;
  position: relative;
}
.addSpace {
  margin-top: 30px;
}

.tools-item-top {
  width: 64px;
  height: 32px;
  border-radius: 2px;
  position: relative;
}

.tools-item-top.hide {
  display: none;
}

.tools-item-left {
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
  box-sizing: border-box;
  width: 234px;
  padding: 12px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);
  border-radius: 4px;
  position: absolute;
  top: 1px;
  right: 80px;
}

.tools-item:hover .tools-item-left {
  opacity: 1;
  visibility: visible;
}

.tools-item-right,
.tools-item-top-right {
  color: rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background: #fff;
  transition: all 0.5s ease;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.tools-item-right:hover {
  width: 76px;
  color: #e63717;
}

.tools-item-right-red {
  background: #e61717;
  color: #fff !important;
}

.tools-item-right-icon {
  width: 24px;
  height: 24px;
}

.tools-item-right-icon1 {
  background: url('https://trial-cdn.esign.cn/upload/ccce32a8-28fa-5a70-989c-9944d898aa29!!5-12.png') no-repeat top left;
  background-size: 24px;
}

.tools-item-right-text {
  margin-top: 2px;
  word-break: break-all;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 0;
}

.tel-tools-item-left {
  /deep/ .desc {
    color: #e61717;
  }
}

.weixin-tools-item-left {
  width: 146px;
  img {
    width: 100%;
  }
  .text {
    text-align: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 17px;
  }
  .text-receive {
    height: 20px;
    background: #e63740;
    border-radius: 10px;
    line-height: 20px;
    color: #ffffff;
  }
}

.tools-card-wrapper {
  display: block;
}

.tools-card-wrapper,
.tools-card {
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

.tools-card {
  padding: 0;
  box-shadow: 0px 0px 4px 0px rgba(235, 235, 235, 0.7);
  cursor: pointer;

  &:hover {
    /deep/ .title .tit-text {
      color: #e63740;
    }
  }

  /deep/ .title .tit-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
  /deep/ .desc {
    padding-top: 4px;
    font-size: 14px;
    line-height: 20px;
  }
}
.img-wrapper {
  width: 61px;
  height: 61px;
  margin-right: 14px;
  img {
    width: 100%;
  }
}
</style>
